import { IRequesterInfo, KeyValuePair } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { addDealerType, addExcludeTestDealers, DealerTypeFilter } from '../analyticsQuery'
import { IChatAnalyticsSummary } from '../models'

export class GetChatbotAnalyticsSummaryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'admin/chatbot-analytics/summary', requesterInfo })
  }

  public async getSummary(
    fromUtc: Date,
    toUtc: Date,
    excludeTestDealers?: boolean,
    dealerType?: DealerTypeFilter
  ): Promise<IChatAnalyticsSummary> {
    const query = new KeyValuePair<string>()
    query.add('fromUtc', fromUtc.toISOString())
    query.add('toUtc', toUtc.toISOString())
    addExcludeTestDealers(query, excludeTestDealers)
    addDealerType(query, dealerType)
    this.queryParams = query
    return await this.getAsync<IChatAnalyticsSummary>()
  }
}
